import serverCall from "../serverCall";

const addMessage = (
  selectedCountry,
  message,
  numberOfUser,
  selectedProvider
) => {
  const response = serverCall.post(
    `/admin/send-message?country=${selectedCountry}&message=${message}&numberOfUser=${numberOfUser}&provider=${selectedProvider}`
  );
  return response;
};

const getCountryProvider = (country) => {
  const response = serverCall.get(`/country/provider?country=${country}`);
  return response;
};

const getCountry = () => {
  const response = serverCall.get(`/country/country`);
  return response;
};

const getMccMnc = (country) => {
  const response = serverCall.get(
    `/admin/dashboard/mnc-mcc?country=${country}`
  );
  return response;
};

const getUsers = (country, mccMnc, numberofuser) => {
  const response = serverCall.get(
    `/admin/dashboard/home/users?countryName=${country}&mccMnc=${mccMnc}&numberOfUser=${numberofuser}`
  );
  return response;
};

const getUsersEveryTime = (body) => {
  const response = serverCall.post(`/admin/dashboard/status`, body);
  return response;
};

const dashboardPushNotification = (userIds) => {
  const response = serverCall.post(`/admin/dashboard/notification`, userIds);
  return response;
};

const DashboardService = {
  addMessage,
  getCountryProvider,
  getCountry,
  getMccMnc,
  getUsers,
  dashboardPushNotification,
  getUsersEveryTime,
};

export default DashboardService;
